(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('NetworkController', NetworkController);

    NetworkController.$inject = ['$scope', '$state', 'Network', 'Principal', 'Connexion', 'Picture', 'Dashboard', 'Profile', 'Organisation', 'DoublonProfile'];

    function NetworkController($scope, $state, Network, Principal, Connexion, Picture, Dashboard, Profile, Organisation, DoublonProfile) {
        var vm = this;
        vm.hide=true;
        vm.isOpen = false;
        vm.accordionArray = [];
        vm.profile = null;
        vm.profileId = null;
        vm.people = [];
        vm.connections = [];

        vm.contributionsLater = [];
        vm.registeredSales = [];
        vm.invitedSales = [];
        vm.archivedSales = [];
        vm.searchText = '';
        vm.pageConnexion = 0;
        vm.hasNextPageConnexion = true;
        vm.connexionsParPage = 20;
        vm.sortingTypes = [{
            label: 'Nom',
            value: 'target.lastName'
        }, {
            label: 'Indice',
            value: 'grade'
        }];
        vm.sortBy = vm.sortingTypes[0];
        vm.search = search;
        vm.updateGrade = updateGrade;
        vm.connect = connect;
        vm.loadMoreConnexions = loadMoreConnexions;
        vm.networkCount = 0;
        vm.networkCountWithGrade3 = 0;


        // Les deux sont liés
        vm.contributionsProfileMap = new Map();
        vm.contributionsProfileValues =  [];

        vm.pageContributionProfile = 0;
        vm.hasNextPageContributionsProfile = true;
        vm.contributionsProfileParPage = 20;
        vm.loadMoreContributionsProfile = loadMoreContributionsProfile;
        vm.busyLoadingContributionsProfile = false;

        vm.contributionsOrganisation= [];
        vm.pageContributionOrganisation = 0;
        vm.hasNextPageContributionsOrganisation = true;
        vm.contributionsOrganisationParPage = 20;
        vm.loadMoreContributionsOrganisation= loadMoreContributionsOrganisation;
        vm.busyLoadingContributionsOrganisation = false;
        vm.busyLoadingConnexions = false;
        vm.aConnecterCount = 0;


        vm.pendingContributionsProfile = [];
        vm.pagePendingContributionProfile = 0;
        vm.hasNextPagePendingContributionsProfile = true;
        vm.pendingContributionsProfileParPage = 20;
        vm.loadMorePendingContributionsProfile = loadMorePendingContributionsProfile;
        vm.busyLoadingPendingContributionsProfile = false;
        vm.myPendingContributionsCount = 0;

        vm.createProfileFromPendingContribution = createProfileFromPendingContribution;
        vm.deletePendingContribution = deletePendingContribution;



        vm.pendingHomonymsProfile = [];
        vm.pagePendingHomonymProfile = 0;
        vm.hasNextPagePendingHomonymsProfile = true;
        vm.pendingHomonymsProfileParPage = 20;
        vm.loadMorePendingHomonymsProfile = loadMorePendingHomonymsProfile;
        vm.busyLoadingPendingHomonymsProfile = false;
        vm.myPendingHomonymsCount = 0;

        vm.createProfileFromPendingHomonym = createProfileFromPendingHomonym;
        vm.deletePendingHomonym = deletePendingHomonym;

        vm.connectProfileFromPendingHomonym = connectProfileFromPendingHomonym;

        vm.deleteAQualifierProfile = deleteAQualifierProfile;

        vm.memePersonne = memePersonne;

        // Connections, people
        $scope.networkBusyPromise =
        Principal.profile().then(function (profile) {
            vm.profile = profile;
            if (profile)
                vm.profileId = profile.id;
        }).then(function(result) {
            return Dashboard.get();
        }).then(function (data) {
            vm.networkCount = data.myNetwork;
            vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
            vm.aConnecterCount = data.aConnecter;
            vm.myPendingContributionsCount = data.pendingContributions;
            vm.myPendingHomonymsCount = data.pendingHomonyms;
        }).then(function (data) {
            //return loadMoreConnexions(true);
        }).then(function (data) {
           //return loadMoreContributions(true);
        }).then(function (data) {
            // registeredSales();
            // invitedSales();
            // archivedSales();
        }).then(function(result) {
            vm.hide = false;
        });



        // Sales
        // Director.querySales({}).$promise.then(function (sales) {
        //     vm.sales = sales;
        // });

        function updateGrade(profile, newGrade, refreshMonReseau) {
            vm.connecting = true;
            var connection = findConnectionById(profile.connectionId);
            connection.grade = newGrade;
            Connexion.update(connection, function (res) {
                profile.grade = newGrade;
                Dashboard.get().then(function (data) {
                    vm.networkCount = data.myNetwork;
                    vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                    vm.aConnecterCount = data.aConnecter;
                    vm.myPendingContributionsCount = data.pendingContributions;
                    vm.myPendingHomonymsCount = data.pendingHomonyms;
                });
                vm.contributionsProfileMap.delete(profile.id);
                vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());
                $scope.$emit('contributionsProfile:updated')

                // Refresh de l'onglet réseau lorsqu'on est sur les autres onglets
                if (refreshMonReseau) {
                    loadMoreConnexions(true);
                }
                vm.connecting = false;
                //vm.loadMoreContributionsProfile(true);
            });
        }

        vm.connecting = false;

        function connect(profile, grade, index) {
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            var connection = findConnectionById(profile.connectionId);

            if (connection){
                updateGrade(profile, grade, true);
            } else {
                insertGrade(profile, grade);
            }
        }


        function connectFromPendingHomonym(profile, grade) {
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            insertGrade(profile, grade);

        }

        function insertGrade(profile, grade){
            vm.profileToConnect = profile.id;
            var connection = {
                creator: {
                    id: vm.profileId
                },
                grade: grade,
                target: {
                    id: profile.id
                }
            };
            Connexion.save(connection, function (res) {
                profile.grade = res.grade;
                profile.connectionId = res.id;
                vm.connections.push(res);
                Dashboard.get().then(function (data) {
                    vm.networkCount = data.myNetwork;
                    vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                    vm.aConnecterCount = data.aConnecter;
                    vm.myPendingContributionsCount = data.pendingContributions;
                    vm.myPendingHomonymsCount = data.pendingHomonyms;
                });
                vm.contributionsProfileMap.delete(profile.id);
                vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());
                $scope.$emit('contributionsProfile:updated')
                loadMoreConnexions(true);
                vm.connecting = false;

            }, angular.noop);
        }

        function findConnectionById(id) {
            var connection = null;
            for (var i = 0; i < vm.connections.length; i++) {
                if (vm.connections[i].id === id) {
                    connection = vm.connections[i];
                }
            }
            return connection;
        }

        function search() {
            vm.pageConnexion = 0;
            if (!vm.searchText) {
                loadMoreConnexions(true);
            } else {
                Network.networkSearch({
                    page: vm.pageConnexion,
                    size: vm.connexionsParPage,
                    query: vm.searchText,
                    sort: vm.sortBy.value
                }, function (connections) {
                    vm.people = [];
                    vm.connections = [];
                    connections.forEach(function (connection) {
                        var people;
                        if (connection.target.id === vm.profileId) {
                            people = connection.creator;
                        } else {
                            people = connection.target;
                        }
                        people.grade = connection.grade;
                        people.connectionId = connection.id;
                        loadPicture(people);
                        vm.connections.push(connection);
                        vm.people.push(people);
                    });
                });
                vm.pageConnexion += 1;
            }
        }

        // Mon réseau
        function loadMoreConnexions(reset) {
            if (reset) vm.pageConnexion = 0;
            if (vm.busyLoadingConnexions) {
                return;
            }
            vm.busyLoadingConnexions = true;
            return Network.getList({
                page: vm.pageConnexion,
                size: vm.connexionsParPage,
                sort: vm.sortBy.value
            }, function (connections, headers) {
                if (reset) {
                    vm.people = [];
                    vm.connections = [];
                }
                vm.hasNextPageConnexion = headers('X-Has-Next-Page') === "true";
                connections.forEach(function (connection) {
                    var people;
                    if (connection.target.id === vm.profileId) {
                        people = connection.creator;
                    } else {
                        people = connection.target;
                    }
                    people.grade = connection.grade;
                    people.connectionId = connection.id;
                    loadPicture(people);
                    var existingConnection = findConnectionById(connection.id);
                    if (!existingConnection){
                        vm.connections.push(connection);
                        vm.people.push(people);
                    }

                });
                vm.pageConnexion += 1;
                vm.busyLoadingConnexions = false;
            }).$promise;

        }


        // A Qualifier/Connecter
        function loadMoreContributionsProfile(reset) {

            if (vm.busyLoadingContributionsProfile) {
                return;
            }
            vm.busyLoadingContributionsProfile = true;

            if (reset) vm.pageContributionProfile = 0;

            return Profile.aConnecter({
                page: vm.pageContributionProfile,
                size: vm.contributionsProfileParPage
            }, function (contributionsProfile, headers) {

                vm.hasNextPageContributionsProfile = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.contributionsProfileMap = new Map();
                    vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());

                }
                contributionsProfile.forEach(function (profile) {
                    loadPicture(profile);
                    vm.contributionsProfileMap.set(profile.id, profile);

                    // Alimentation de l'onglet connexion à partir des contribs
                    /*
                    if (profile.connectionId){
                        var connection = findConnectionById(profile.connectionId);
                        if (!connection){
                            var connection = {};
                            connection.target = profile;
                            connection.creator = vm.profile;
                            connection.grade = profile.grade;
                            connection.id = profile.connectionId;

                            var people;
                            if (connection.target.id === vm.profileId) {
                                people = vm.profile;
                            } else {
                                people = profile;
                            }
                            people.grade = profile.grade;
                            people.connectionId = profile.connectionId;
                            loadPicture(people);
                            vm.connections.push(connection);
                            vm.people.push(people);
                        }
                    }
                    */


                });
                vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());
                vm.pageContributionProfile += 1;
                vm.busyLoadingContributionsProfile = false;
            }).$promise;
        }

        function loadMoreContributionsOrganisation(reset) {
            if (vm.busyLoadingContributionsOrganisation) {
                return;
            }
            vm.busyLoadingContributionsOrganisation = true;

            if (reset) vm.pageContributionOrganisation = 0;

            return Organisation.myContributions({
                page: vm.pageContributionOrganisation,
                size: vm.contributionsOrganisationParPage
            }, function (contributionsOrga, headers) {
                vm.hasNextPageContributionsOrganisation = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.contributionsOrganisation = [];
                }
                contributionsOrga.forEach(function (orga) {
                    vm.contributionsOrganisation.push(orga);
                });
                vm.pageContributionOrganisation += 1;
                vm.busyLoadingContributionsOrganisation = false;
            }).$promise;
        }



        function invitedSales() {
            var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
            if (vm.profile && isDgOrAdmin) {
                Connexion.allInternalNetworkDGInvited({}, function (users) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    users.forEach(function (user) {
                        vm.invitedSales.push(user);
                    });
                });
            }
            /*
            else if (vm.profile && !isDgOrAdmin) {
                Connexion.allInternalNetworkCommercial({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            } else {
                Network.getList({
                    organisationId: vm.organisation.id
                }, function (connections) {
                    //var network = organisationNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            }
            */
        }


        function registeredSales() {
            var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
            if (vm.profile && isDgOrAdmin) {
                Connexion.allInternalNetworkDG({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    connections.forEach(function (connection) {
                        var people;
                        if (connection.target.id === vm.profileId) {
                            people = connection.creator;
                        } else {
                            people = connection.target;
                        }

                        people.grade = connection.grade;
                        people.connectionId = connection.id;
                        people.creator = connection.creator;
                        loadPicture(people);
                        vm.registeredSales.push(people);
                    });
                });
            }
            /*
            else if (vm.profile && !isDgOrAdmin) {
                Connexion.allInternalNetworkCommercial({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            } else {
                Network.getList({
                    organisationId: vm.organisation.id
                }, function (connections) {
                    //var network = organisationNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            }
            */
        }

        function archivedSales() {
            var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
            if (vm.profile && isDgOrAdmin) {
                Connexion.allInternalNetworkDGArchived({}, function (users) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    users.forEach(function (user) {
                        vm.archivedSales.push(user);
                    });
                });
            }
            /*
            else if (vm.profile && !isDgOrAdmin) {
                Connexion.allInternalNetworkCommercial({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            } else {
                Network.getList({
                    organisationId: vm.organisation.id
                }, function (connections) {
                    //var network = organisationNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            }
            */
        }

        // A Valider (en attente de création, job non safe)
        function loadMorePendingContributionsProfile(reset) {
            if (vm.busyLoadingPendingContributionsProfile) {
                return;
            }
            vm.busyLoadingPendingContributionsProfile = true;

            if (reset) vm.pagePendingContributionProfile = 0;

            return DoublonProfile.myPendingContributions({
                page: vm.pagePendingContributionProfile,
                size: vm.pendingContributionsProfileParPage
            }, function (pendingContributionsProfile, headers) {

                vm.hasNextPagePendingContributionsProfile = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.pendingContributionsProfile = [];
                }
                pendingContributionsProfile.forEach(function (profile) {
                    loadPicture(profile);
                    vm.pendingContributionsProfile.push(profile);
                });
                vm.pagePendingContributionProfile += 1;
                vm.busyLoadingPendingContributionsProfile = false;
            }).$promise;
        }

        function deletePendingContribution(pendingContrib){
            DoublonProfile.deletePendingContribution({id: pendingContrib.id},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingContributionsProfile(true);
                });
        }

        function createProfileFromPendingContribution(pendingContrib, grade){
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            DoublonProfile.createProfileFromPendingContribution({id: pendingContrib.id, grade:grade}, {},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingContributionsProfile(true);
                    vm.connecting = false;
                });
        }

        function loadMorePendingHomonymsProfile(reset) {
            if (vm.busyLoadingPendingHomonymsProfile) {
                return;
            }
            vm.busyLoadingPendingHomonymsProfile = true;

            if (reset) vm.pagePendingHomonymProfile = 0;

            return DoublonProfile.myPendingHomonyms({
                page: vm.pagePendingHomonymProfile,
                size: vm.pendingHomonymsProfileParPage
            }, function (pendingHomonymsProfile, headers) {

                vm.hasNextPagePendingHomonymsProfile = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.pendingHomonymsProfile = [];
                }
                pendingHomonymsProfile.forEach(function (profile) {
                    loadPicture(profile);
                    vm.pendingHomonymsProfile.push(profile);
                });
                vm.pagePendingHomonymProfile += 1;
                vm.busyLoadingPendingHomonymsProfile = false;
            }).$promise;
        }


        function deletePendingHomonym(pendingContrib){
            DoublonProfile.deletePendingHomonym({id: pendingContrib.id},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingHomonymsProfile(true);
                });
        }

        function createProfileFromPendingHomonym(pendingContrib, grade){

            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            DoublonProfile.createProfileFromPendingHomonym({id: pendingContrib.id, grade:grade}, {},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingHomonymsProfile(true);
                    vm.connecting = false;
                });
        }

        function connectProfileFromPendingHomonym(pendingContrib, grade){
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            DoublonProfile.connectProfileFromPendingHomonym({id: pendingContrib.id, grade:grade}, {},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingHomonymsProfile(true);
                    vm.connecting = false;
                });
        }

        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture=response;
                }, function (response) {
                });
            }
        }

        function deleteAQualifierProfile(id) {
            if (vm.profile.id !== null) {
                Profile.delete({
                    id: id
                }, onDeleteAQualifierProfileSuccess, onDeleteAQualifierProfileError);
            }
        }

        function onDeleteAQualifierProfileSuccess(result) {

            Dashboard.get().then(function (data) {
                vm.networkCount = data.myNetwork;
                vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                vm.aConnecterCount = data.aConnecter;
                vm.myPendingContributionsCount = data.pendingContributions;
                vm.myPendingHomonymsCount = data.pendingHomonyms;
            });
            vm.loadMoreContributionsProfile(true);

            $scope.$emit('quilinkApp:profileDelete', null);
        }
        function onDeleteAQualifierProfileError() {
        }

        function memePersonne(contrib, memePersonne) {
            contrib.memePersonne = memePersonne;
        }
    }
})();
